"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAbsoluteUrl = void 0;
exports.isAllowedDomain = isAllowedDomain;
function getUrlDomain(href) {
    var a = document.createElement('a');
    a.href = href;
    return a.hostname;
}
function isAllowedDomain(testDomain, allowedDomains) {
    var originDomain = getUrlDomain(testDomain);
    var matchedDomains = allowedDomains.filter ? allowedDomains.filter(function (allowedDomain) {
        if (allowedDomain[0] === '*') {
            var testRegex = new RegExp("^.*".concat(allowedDomain.slice(1), "$"));
            return testRegex.test(originDomain);
        }
        return allowedDomain === originDomain;
    }) : [];
    return !!matchedDomains.length;
}
var isAbsoluteUrl = function (url) {
    var r = new RegExp('^(?:[a-z]+:)?//', 'i');
    return r.test(url);
};
exports.isAbsoluteUrl = isAbsoluteUrl;
//# sourceMappingURL=url.js.map